<template>
  <div
    class="wrapper"
    :style="{
      backgroundImage: `url(${image.ImgthumbBlurLarge})`,
      backgroundPosition: '0 0',
    }"
  >
    <div
      class="colorOverlay"
      :style="{
        background: '#000',
        opacity: 0.3,
      }"
    />
    <div
      class="colorOverlay"
      :style="{

       background: `linear-gradient(45deg, #${content.colordark}, #${content.colorlight})`,
      }"
    />
    <!-- stats -->
    <div class="wrapper__stats">
      <!-- <h4>Key stats</h4> -->
      <ul>
        <li
          v-for="label in Object.keys(keyStats)"
          :key="`stat-${label}`"
        >
          <h5>{{ label }}</h5>
          <p>{{ keyStats[label] }}</p>
        </li>
      </ul>
    </div>
    <hr />
    <!-- caption -->
    <p>{{ content.caption }}</p>

    <div v-if="footerStats" class="wrapper__stats">
      <hr />
      <!-- <h4>Key stats</h4> -->
      <ul>
        <li
          v-for="label in Object.keys(footerStats)"
          :key="`stat-${label}`"
        >
          <h5>{{ label }}</h5>
          <p>{{ footerStats[label] }}</p>
        </li>
      </ul>
    </div>
    <!-- <runners-up
      v-if="content.runnersup"
      :players="content.runnersup"
    /> -->

  </div>

</template>


<script>
import RunnersUp from '@/components/dally-m/runner-up.vue'

export default {
  name: 'team-bottom',
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  components: {
    RunnersUp,
  },
  data () {
    return {}
  },
  methods: {},
  computed: {
    // runnersup () {
    //   return this.content.runnersup
    //     .split(',')
    //     .map(name => name.trim())
    // },
    keyStats () {
      return {
        [this.content.stat1label]: this.content.stat1value,
        [this.content.stat2label]: this.content.stat2value,
        [this.content.stat3label]: this.content.stat3value,
        [this.content.stat4label]: this.content.stat4value,
      }
      // return Object.keys(this.content)
      //   .filter(k => k.includes('stat'))
      //   .reduce((output, key, i) => {
      //     const update = output
      //     const index = key
      //       .replace(/stat/gi, '')
      //       .replace(/value/gi, '')
      //       .replace(/label/gi, '')
      //     const label = this.content[`stat${index}label`]
      //     const value = this.content[`stat${index}value`]
      //     update[label] = value
      //     return update
      //   }, {})
    },
    footerStats () {
      return false
      // return {
      //   [this.content.stat1label]: this.content.stat1value,
      //   [this.content.stat2label]: this.content.stat2value,
      // }
    },
    image () {
      // const name = this.content.name
      //   .replace(/\s+/gi, '')
      //   .toLowerCase()
      return this.$root.content.allImages[this.content.image]
    },
    badge () {
      // const team = this.$root.content.teams[this.content.team.toLowerCase().replace(/\s+/gi, '_')]
      const badgeInfo = this.$root.content.teams.tigers
      return badgeInfo
    },
  },
}
</script>


<style scoped lang="sass">
@import index

// *
  // outline: solid 1px red


.wrapper
  padding: 24px
  color: white
  h4
    text-transform: uppercase
    text-align: center
  ul
    display: flex
    justify-content: center
    padding: 0
    li
      flex: 1 1 auto
      width: 30%
      list-style: none
      text-align: center
      margin: 0
      padding: 0
  &__stats
    ul
      display: flex
      flex-wrap: wrap
      li
        flex: 1 1 auto
        min-width: 120px
        width: 50%
        @media screen and (min-width: 500px)
          width: 20%
        margin-bottom: 16px
        padding: 0 4px
        &:last-of-type
          margin-bottom: 0
        h5
          text-align: center
          text-transform: uppercase
          letter-spacing: 1px
          opacity: 0.6
          margin-bottom: 4px
        p
          margin: 0
          font-size: 24px
          line-height: 24px
  hr
    border-color: rgba(white, 0.1)

  .colorOverlay
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    z-index: 0
    opacity: 0.3

</style>



// WEBPACK FOOTER //
// src/components/dally-m/team-bottom.vue